import React, { forwardRef } from "react";

import { styled, lighten } from "@mui/material/styles";
import { Button as MuiButton } from "@mui/material";

interface Params {
  value: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Button = styled(MuiButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  margin: "0 10px",

  "&:hover": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.75),
  },
}));

export const CustomButton = forwardRef(({ value, onClick }: Params, _ref: any) => (
  <Button
    variant="contained"
    onClick={onClick}
    ref={_ref}
    style={{ margin: 0 }}
  >
    {value}
  </Button>
));
